import ProductPageSpinner from './product-page-spinner';

export default ProductPageSpinner;
